module.exports = __webpack_public_path__ + "static/media/icon_1.32202483.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_1.png
// module id = 1895
// module chunks = 0 1